// @ts-nocheck
(function () {
  if (window.__googleCombinedListingTrackerInit) return;
  window.__googleCombinedListingTrackerInit = true;

  // Google Ads "view_item" for a combined-listing colour switch. The Google & YouTube app sends view_item from
  // Shopify's product_viewed event, which only fires on a page load, and a colour switch shows the new product
  // without one (assets/variant-picker.js). This sends the same event for the new product. The conversion
  // label (send_to) and the visitor fields come from the app's own view_item for this page in window.dataLayer,
  // so nothing about the Google Ads account is copied into the theme; without that event, nothing is sent.
  function appViewItem() {
    var dataLayer = window.dataLayer;
    if (!dataLayer || !dataLayer.length) return null;
    for (var i = dataLayer.length - 1; i >= 0; i--) {
      var entry = dataLayer[i];
      if (entry && entry[0] === 'event' && entry[1] === 'view_item' && entry[2] && entry[2].send_to) return entry[2];
    }
    return null;
  }

  // On a switch, assets/variant-picker.js has already copied the new product's data into window.__klProduct
  // and window.__fbProduct (snippets/product-tracking-data.liquid) before variant:update is dispatched.
  document.addEventListener('variant:update', function (e) {
    var detail = e.detail;
    if (!detail || !detail.resource || !detail.data || !detail.data.mainMorphed) return;
    if (typeof gtag !== 'function') return;

    var appEvent = appViewItem();
    var kl = window.__klProduct;
    if (!appEvent || !kl || !kl.ProductID) return;

    var variant = detail.resource;
    var fb = window.__fbProduct || {};
    var price = variant.price != null ? variant.price / 100 : 0;
    // The app's item ids are shopify_<country>_<product id>_<variant id> (the Merchant Center ids).
    var firstItem = appEvent.items && appEvent.items[0];
    var country = (firstItem && String(firstItem.id).split('_')[1]) || 'US';
    var itemId = 'shopify_' + country + '_' + kl.ProductID + '_' + variant.id;

    var params = {
      send_to: appEvent.send_to,
      ecomm_prodid: [itemId],
      ecomm_totalvalue: price,
      ecomm_pagetype: 'product',
      value: price,
      currency: appEvent.currency || 'USD',
      items: [{
        id: itemId,
        name: kl.Name,
        brand: fb.vendor || kl.Brand || '',
        category: fb.type || '',
        price: price,
        variant: variant.title,
        quantity: 1,
        sku: variant.sku || '',
        variant_id: String(variant.id)
      }]
    };
    // Fields about the visitor and the integration, not the product. The app's event_id is left out: it names
    // the page-load event, and reusing it could get this event dropped as a duplicate.
    ['developer_id', 'ext_client_id', 'shopify_event_name', 'user_data'].forEach(function (key) {
      if (appEvent[key] !== undefined) params[key] = appEvent[key];
    });

    gtag('event', 'view_item', params);
  });
})();
